import type { UseFormSetValue } from "react-hook-form";
import type { SignupFormData } from "@/lib/formValidation";
import type { ReferralPartnerSummary } from "@/lib/types";
import { bindDevToolboxScenarioIdListener } from "@/lib/devToolbox/bindScenarioListener";
import { isDevToolboxEnabled } from "@/lib/devToolbox/isDevToolboxEnabled";
import type { DevToolboxScenarioId } from "@/lib/devToolbox/types";

export type SignupDevToolboxContext = {
  setValue: UseFormSetValue<SignupFormData>;
  setResolvedPartner: (partner: ReferralPartnerSummary | null) => void;
  setPartnerLookupError: (error: string | null) => void;
  setIsPartnerLocked: (locked: boolean) => void;
  setLockedReferralCode: (code: string | null) => void;
};

export function applyDevToolboxScenario(
  scenarioId: DevToolboxScenarioId | null,
  context: SignupDevToolboxContext,
): void {
  if (!scenarioId) return;

  const {
    setValue,
    setResolvedPartner,
    setPartnerLookupError,
    setIsPartnerLocked,
    setLockedReferralCode,
  } = context;

  if (scenarioId === "signup.market-partner.valid") {
    setValue("discoveryChannel", "market_partner", { shouldValidate: true });
    setValue("partnerReferralCode", "VALIDPARTNER1", { shouldValidate: true });
    setResolvedPartner({
      id: "dev-partner-001",
      name: "Demo Market Partner",
    });
    setPartnerLookupError(null);
    setIsPartnerLocked(false);
    setLockedReferralCode(null);
    return;
  }

  if (scenarioId === "signup.market-partner.invalid") {
    setValue("discoveryChannel", "market_partner", { shouldValidate: true });
    setValue("partnerReferralCode", "INVALIDCODE1", { shouldValidate: true });
    setResolvedPartner(null);
    setPartnerLookupError("We couldn't find that market partner code");
    setIsPartnerLocked(false);
    setLockedReferralCode(null);
  }
}

export function subscribeSignupDevToolboxAdapter(
  context: SignupDevToolboxContext,
): () => void {
  if (!isDevToolboxEnabled()) return () => {};

  return bindDevToolboxScenarioIdListener((scenarioId) =>
    applyDevToolboxScenario(scenarioId, context),
  );
}
